module.exports = __webpack_public_path__ + "img/bg_stage.a42374ca.jpg";